import { loginInvestor, logoutInvestor, me } from './apiGateway';
import checkK1ConsentNudge from '../helpers/checkK1ConsentNudge';

export const INIT_SESSION = 'INIT_SESSION';
export const INIT_SESSION_SUCCESS = 'INIT_SESSION_SUCCESS';
export const INIT_SESSION_FAILURE = 'INIT_SESSION_FAILURE';

export const DO_SIGN_IN = 'DO_SIGN_IN';
export const AUTHENTICATED = 'AUTHENTICATED';
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const DO_LOG_OUT = 'DO_LOG_OUT';
export const SIGNEDOUT = 'SIGNEDOUT';

export const AUTH_TYPE = { USER: 'USER', ADMIN: 'ADMIN', MANAGED: 'MANAGED' };

export const AUTHENTICATION_COOKIE_QUERY_PARAM = 'authenticationCookie';

export function authenticated(user) {
  return {
    type: AUTHENTICATED,
    user,
  };
}

export async function initSession(dispatch, authType = AUTH_TYPE.USER) {
  try {
    dispatch({
      type: INIT_SESSION,
      apiPath: process.env.AVG_API_PATH,
      authType,
    });

    const queryParams = new URLSearchParams(window.location.search);
    const authCookie = queryParams.get(AUTHENTICATION_COOKIE_QUERY_PARAM);
    if (authCookie) {
      document.cookie = `${
        process.env.SESSION_COOKIE_NAME
      }=${authCookie}; max-age=1209540; path=/; sameSite=lax; domain=.${window.location.hostname
        .split('.')
        .slice(-2)
        .join('.')}`;
    }

    const authState = await me();

    if (authState === 'aborted') {
      throw new Error('Failed to validate session');
    }

    if (authState.isLoggedIn) {
      if (authType === AUTH_TYPE.MANAGED && !authState.managerUserEmail) {
        dispatch({ type: INIT_SESSION_FAILURE });
        return false;
      }
      if (authType === AUTH_TYPE.USER && authState.managerUserEmail) {
        dispatch({ type: INIT_SESSION_FAILURE });
        return false;
      }
      dispatch({
        ...authState,
        user: {
          ...authState.user,
          users: authState.user.managedUsers ? Object.values(authState.user.managedUsers) : [],
          isInvestor: 1,
          adminEmail: authState.adminEmail,
        },
        type: INIT_SESSION_SUCCESS,
      });
      return authState;
    }

    // TODO: determine how to do managed logins
    if (authType === AUTH_TYPE.MANAGED) {
      dispatch({ type: INIT_SESSION_FAILURE });
      return authState;
    }

    if (authState.user && authType === AUTH_TYPE.USER) {
      dispatch({
        user: {
          ...authState.user,
          isInvestor: 1,
          adminEmail: authState.adminEmail,
        },
        type: INIT_SESSION_SUCCESS,
      });
    }

    return authState;
  } catch (error) {
    dispatch({ type: INIT_SESSION_FAILURE });
    return false;
  }
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export async function doSignIn(dispatch, credentials) {
  try {
    const loginResponse = await loginInvestor(credentials);
    const { resourceAccessToken, isMFANudgeRequired } = loginResponse;
    if (resourceAccessToken && isMFANudgeRequired) {
      const encodedRedirect = encodeURIComponent(window.location.href);
      window.location.href = `${process.env.AV_VC_PATH}/mfa-setup?resourceAccessToken=${resourceAccessToken}&redirect=${encodedRedirect}`;
      await sleep(2000);
      return;
    }
    else if (resourceAccessToken) {
      const encodedRedirect = encodeURIComponent(window.location.href);
      window.location.href = `${process.env.AV_VC_PATH}/login/otp-challenge?resourceAccessToken=${loginResponse.resourceAccessToken}&redirect=${encodedRedirect}`;
      await sleep(2000);
      return;
    }

    const isK1ConsentNudgeRequired = await checkK1ConsentNudge();
    if (isK1ConsentNudgeRequired) {
      const encodedRedirect = encodeURIComponent(window.location.href);
      window.location.href = `${process.env.AV_VC_PATH}/paperless-k1-consent?redirect=${encodedRedirect}`;
      await sleep(2000);
      return;
    }

    dispatch({ type: DO_SIGN_IN });

    const userWithInvestorStatus = {
      ...loginResponse.user,
      isInvestor: 1,
    };
    dispatch(authenticated(userWithInvestorStatus));

    return userWithInvestorStatus;
  } catch (error) {
    dispatch({ type: SIGN_IN_ERROR });
    // error message handled by request helper
    return {
      success: false,
      message: error.message,
      code: error.code,
    };
  }
}

export async function doLogOut(dispatch) {
  await logoutInvestor();
  dispatch({ type: DO_LOG_OUT });
}

export function signedout() {
  return { type: SIGNEDOUT };
}

export default {
  initSession,
  doSignIn,
  doLogOut,
  authenticated,
  signedout,
  AUTH_TYPE,
};
